import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MapQueryService {

  constructor(private http: HttpClient,private analytics: AngularFireAnalytics) { }


  queryLocationByAddress(ciudad: string):Promise<any>{
    this.analytics.logEvent('consulta_localidad',{query:ciudad})
    var url="https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBMFeYfHbQ_NGP8rEgklf6nIWiAA-liakY&address=";
    return new Promise((resolve,reject)=>{
      var options={params:{location:ciudad}};
      this.http.get(url+ciudad).subscribe((response) => {
        let jresponse=response;
        console.log(jresponse)
        if(jresponse['results'].length>0){

          resolve(jresponse['results'][0].geometry.location);
        }
      });
    });
  }
}
